import API from './services/api'
import { notification } from './services/notification'

import ButtonDeleteReservation from './button-delete-reservation'
import Carousel from './carousel'
import VueComponents from './vue-component'

export default class AsyncPage {
  constructor(element) {
    this.element = element

    return new Promise((resolve, reject) => {
      if (!this.element) {
        // reject(new Error('Element not found'))
        return
      }

      API.get(this.element.dataset.api)
        .then((response) => {
          this.element.innerHTML = response.html
          this.element.classList.remove('is-loading')

          requestAnimationFrame(() => {
            this.initComponents()
            resolve(this.element)
          })
        })
        .catch((error) => {
          this.element.classList.remove('is-loading')
          notification.toast.add({
            severity: 'error',
            summary: 'Eroare',
            detail: error.message,
            life: 4000,
          })

          // resolve(this.element)
        })
    })
  }

  initComponents() {
    this.vueComponents = new VueComponents(this.element)
    this.buttonDeleteReservation = new ButtonDeleteReservation()

    this.carousels = {
      tickets: new Carousel(
        '.swiper.is-tickets',
        {
          freeMode: true,
          edgeSwipeDetection: 'prevent',
          spaceBetween: 12,
          slidesPerView: 'auto',
        },
        this.element,
      ),
      list: new Carousel(
        '.swiper.is-list.is-default',
        {
          freeMode: true,
          edgeSwipeDetection: 'prevent',
          slidesPerView: 1.05,
          spaceBetween: 12,
          breakpoints: {
            768: { slidesPerView: 2.3 },
            1024: { slidesPerView: 3.3, spaceBetween: 24 },
            1366: { slidesPerView: 4.3, spaceBetween: 24 },
          },
        },
        this.element,
      ),
    }
  }
}
